module.exports = __webpack_public_path__ + "static/media/logo.982af770.png";